module.exports = __webpack_public_path__ + "img/simon.5cde4aaa.jpg";